module.exports = "/_next/static/images/078284f92ee23885ec652ef12b380cca-careers@2x.jpg.webp";